module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Műveletek")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "type",
      "label": "Típus",
      "name": "type",
      "options": _vm.types
    },
    model: {
      value: (_vm.search.type_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "type_id", $$v)
      },
      expression: "search.type_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_c('toggle', {
    attrs: {
      "id": "inout",
      "label": "Végrehajtott",
      "name": "inout"
    },
    model: {
      value: (_vm.search.inout),
      callback: function($$v) {
        _vm.$set(_vm.search, "inout", $$v)
      },
      expression: "search.inout"
    }
  })], 1)]), _vm._v(" "), (_vm.operations.length > 0) ? _c('div', {
    staticClass: "table-with-title"
  }, [_c('h2', [_vm._v("Műveletek")]), _vm._v(" "), _c('table', {
    staticClass: "list"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.operations), function(operation, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(operation.created))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operation.name))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-info-circle",
      staticStyle: {
        "font-size": "18px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.showParamsPopup(operation)
        }
      }
    })])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.operations.length == 0) ? _c('div', {
    staticClass: "normal-text"
  }, [_vm._v("\n            Nem található művelet.\n          ")]) : _vm._e()])])], 1), _vm._v(" "), (_vm.params_popup.visible) ? _c('div', {
    staticClass: "popup-overlayer"
  }, [_c('div', {
    staticClass: "popup",
    staticStyle: {
      "min-width": "500px"
    }
  }, [_c('a', {
    staticClass: "close-btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.hideParamsPopup
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _vm._v(" "), _c('h2', [_vm._v("Paraméterek")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  })])]) : _vm._e(), _vm._v(" "), _c('HTMLFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v("Kereső")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Létrehozva")]), _vm._v(" "), _c('th', [_vm._v("Típus")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-580c5590"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/operations.vue
// module id = 303
// module chunks = 0